<template>
  <div
    id="app"
    class="min-h-screen bg-white-100 flex items-center justify-center"
  >
    <div
      class="relative w-full md:h-[calc(100vh-4vh)] md:m-[2vh] md:rounded-[20px] h-full shadow-2xl overflow-hidden bg-cover bg-center bg-full-screen"
    >
      <NavBar class="relative z-20 lg:m-[2vh] lg:mt-[4vh]" />

      <div
        class="absolute inset-0 lg:pt-[15vh] pt-[27vh] w-full h-full backdrop-blur-sm bg-black/30 z-10 p-4"
      >
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue' // NavBar'ı içe aktarın

export default {
  name: 'App',
  components: {
    NavBar, // component olarak tanımlayın
  },
}
</script>

<style scoped></style>
